module.exports = __webpack_public_path__ + "media/images/athletes/3442-c82c3c42b8e6d80b3c4f90df688a124a.png";